import { useCallback, useEffect, useState, useRef, useMemo } from 'react'
import { Currency, Token } from '@pancakeswap/sdk'
import { ChainId } from '@pancakeswap/chains'
import { styled } from 'styled-components'
import {
  Button,
  Text,
  ArrowUpIcon,
  Link,
  Modal,
  InjectedModalProps,
  ModalProps,
  BscScanIcon,
  AutoColumn,
  ColumnCenter,
} from '@pancakeswap/uikit'
import { ConfirmationPendingContent } from '@pancakeswap/widgets-internal'
import { useTranslation } from '@pancakeswap/localization'
import { wrappedCurrency } from 'utils/wrappedCurrency'
import { WrappedTokenInfo } from '@pancakeswap/token-lists'
import { useActiveChainId } from 'hooks/useActiveChainId'
import { getBlockExploreLink, getBlockExploreName } from 'utils'
import AddToWalletButton, { AddToWalletTextOptions } from '../AddToWallet/AddToWalletButton'

const Wrapper = styled.div`
  width: 100%;
  max-width: 600px;
`
const Section = styled(AutoColumn)`
  padding: 24px;
`

const ConfirmedIcon = styled(ColumnCenter)`
  padding: 24px 0;
`

export function TransactionSubmittedContent({
  onDismiss,
  chainId,
  hash,
  currencyToAdd,
}: {
  onDismiss: () => void
  hash: string | undefined
  chainId: ChainId
  currencyToAdd?: Currency | undefined
}) {
  const { t } = useTranslation()
  // const { toastSuccess } = useToast()

  const token: Token | undefined = wrappedCurrency(currencyToAdd, chainId)

  // useEffect(() => {
  //   if (hash) {
  //     toastSuccess(
  //       t('Transaction Submitted'),
  //       <Text>
  //         <Link external small href={getBlockExploreLink(hash, 'transaction', chainId)}>
  //           {t('View on %site%', {
  //             site: getBlockExploreName(chainId),
  //           })}
  //         </Link>
  //       </Text>
  //     )
  //   }
  // }, [chainId, hash, t, toastSuccess])

  return (
    <Wrapper>
      <Section>
        <ConfirmedIcon>
          <ArrowUpIcon strokeWidth={0.5} width="90px" color="primary" />
        </ConfirmedIcon>
        <AutoColumn gap="12px" justify="center">
          <Text fontSize="20px">{t('Transaction Submitted')}</Text>
          {chainId && hash && (
            <Link external small href={getBlockExploreLink(hash, 'transaction', chainId)}>
              {t('View on %site%', {
                site: getBlockExploreName(chainId),
              })}
              {chainId === ChainId.BSC && <BscScanIcon color="primary" ml="4px" />}
            </Link>
          )}
          {currencyToAdd && (
            <AddToWalletButton
              mt="39px"
              height="auto"
              variant="primary"
              width="fit-content"
              padding="10px 20px"
              marginTextBetweenLogo="6px"
              textOptions={AddToWalletTextOptions.TEXT_WITH_ASSET}
              tokenAddress={token.address}
              tokenSymbol={currencyToAdd.symbol}
              tokenDecimals={token.decimals}
              tokenLogo={token instanceof WrappedTokenInfo ? token.logoURI : undefined}
            />
          )}
          <Button onClick={onDismiss} mt="20px">
            {t('Close')}
          </Button>
        </AutoColumn>
      </Section>
    </Wrapper>
  )
}

interface ConfirmationModalProps {
  title: string
  customOnDismiss?: () => void
  hash: string | undefined
  content: () => React.ReactNode
  attemptingTxn: boolean
  pendingText: string
  currencyToAdd?: Currency | undefined
}

const TransactionConfirmationModal: React.FC<
  React.PropsWithChildren<InjectedModalProps & ConfirmationModalProps & ModalProps>
> = ({ title, onDismiss, customOnDismiss, attemptingTxn, hash, pendingText, content, currencyToAdd, ...props }) => {
  const { chainId } = useActiveChainId()
  const { t } = useTranslation()
  // const { toastError, toastSuccess, toastInfo } = useToast()
  const [attempted, setAttempted] = useState(false)
  // const [lastAttemptingTxn, setLastAttemptingTxn] = useState(false)
  // const timerRef = useRef<NodeJS.Timeout | null>(null)

  const handleDismiss = useCallback(() => {
    if (customOnDismiss) {
      customOnDismiss()
    }
    onDismiss?.()
  }, [customOnDismiss, onDismiss])

  useEffect(() => {
  // //   // if (lastAttemptingTxn && !attemptingTxn) {
  // //   //   if (hash) {
  // //   //     // Transaction successful
  // //   //     toastSuccess(
  // //   //       t('Transaction Submitted'),
  // //   //       <Text>
  // //   //         <Link external small href={getBlockExploreLink(hash, 'transaction', chainId)}>
  // //   //           {t('View on %site%', {
  // //   //             site: getBlockExploreName(chainId),
  // //   //           })}
  // //   //         </Link>
  // //   //       </Text>
  // //   //     )
  // //   //   } else {
  // //   //     // Transaction cancelled
  // //   //     toastInfo(t('Transaction Cancelled'), t('You have cancelled the transaction.'))
  // //   //   }
  // //   // } else if (attemptingTxn) {
  // //   //   // Clear any existing timer when a new transaction is attempted
  // //   //   if (timerRef.current) {
  // //   //     clearTimeout(timerRef.current)
  // //   //   }
  // //   // }
    if (attemptingTxn) {
      setAttempted(true)
    }
    // setLastAttemptingTxn(attemptingTxn)
    if (attempted && !attemptingTxn) {
      handleDismiss()
    }
  }, [attemptingTxn, attempted, handleDismiss])

  if (!chainId) return null

  return (
    <Modal title={attemptingTxn || attempted ? t("Confirmation") : title} headerBackground="gradientCardHeader" {...props} onDismiss={handleDismiss}>
      {(attemptingTxn || attempted) ? (
        <ConfirmationPendingContent pendingText={pendingText} />
      // ) : hash ? (
      //   null
        // <TransactionSubmittedContent
        //   chainId={chainId}
        //   hash={hash}
        //   onDismiss={handleDismiss}
        //   currencyToAdd={currencyToAdd}
        // />
      ) : (
        content()
      )}
    </Modal>
  )
}

export default TransactionConfirmationModal
